import React, { useState, useEffect, useRef } from 'react';
import { useStyles } from '../../../lib/hooks/useStyles';
import theme from '../../../lib/themes/linkpick/new_theme';

export const Autocomplete2 = ({ 
  options = [], 
  placeholder = "Sélectionnez une option", 
  onChange, 
  onInputChange,
  error,
  disabled = false,
  required = false,
  className,
  style,
  passOptionObject = false,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const containerRef = useRef(null);
  
  const { css } = useStyles(styles);

  useEffect(() => {
    if (!isDropdownOpen) return;
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (onInputChange) {
      onInputChange(e);
    }
    const filtered = options.filter(option => 
      option.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered);
    setIsDropdownOpen(true);
  };

  const handleOptionClick = (option) => {
    setInputValue(option.label);
    if (onChange) {
      onChange(option);
    }
    setIsDropdownOpen(false);
  };

  return (
    <div className={css(theme.components.autocomplete.container)} ref={containerRef}>
      <div 
        className={css(
          theme.components.autocomplete.inputContainer,
          error && theme.components.autocomplete.error,
          isHovered && theme.components.autocomplete.hover,
          isFocused && theme.components.autocomplete.focus
        )}
        style={style}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <input
          className={css(theme.components.autocomplete.input)}
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
        />
      </div>

      {isDropdownOpen && !disabled && (
        <div className={css(theme.components.autocomplete.optionsList)}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                onClick={() => handleOptionClick(option)}
                onMouseEnter={() => setHoveredOption(option)}
                onMouseLeave={() => setHoveredOption(null)}
                className={css(
                  theme.components.autocomplete.option,
                  (inputValue === option.label || hoveredOption === option) && theme.components.autocomplete.optionSelected
                )}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div className={css(theme.components.autocomplete.noOptions)}>
              Aucune option trouvée
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const styles = () => ({
  container: theme.components.autocomplete.container,
  input: theme.components.autocomplete.input
});
